import { createContext, useContext, useReducer } from 'react';
import * as constants from '../utils/constants';
import {
	TState,
	TAction,
	TAppProviderProps,
	TDispatch,
} from './AppContextTypes';
import { initialState } from './AppContextInitState';
import { hasValue } from '../utils/hasValue';

const AppContext = createContext<{
	state: TState;
	dispatch: TDispatch;
}>({ state: initialState, dispatch: () => null });

const appReducer = (state: TState, action: TAction) => {
	switch (action.type) {
		case constants.SET_INACTIVE:
			return {
				...state,
				inactive: action.data,
			};
		case constants.SET_USER_PROFILING:
			return {
				...state,
				userProfiling: action.data,
			};
		case constants.SET_USER_CONTACT_INFORMATION:
			return {
				...state,
				userContactInformation: action.data,
			};
		case constants.SET_BANNERS:
			return {
				...state,
				banners: action.data,
			};
		case constants.SET_ACCOUNT:
			return {
				...state,
				account: action.data,
			};
		case constants.SET_LIST_ACCOUNTS:
			return {
				...state,
				listAccounts: action.data,
			};
		case constants.SET_LIST_JOINT_ACCOUNTS:
			return {
				...state,
				listJointAccounts: action.data,
			};
		case constants.SET_LIST_AUTONOMOUS_ACCOUNTS:
			return {
				...state,
				listAutonomousAccounts: action.data,
			};
		case constants.SET_AUTONOMOUS_ACCOUNT:
			return {
				...state,
				autonomousAccount: action.data,
			};
		case constants.SET_LIST_BENEFICIARIES:
			return {
				...state,
				listBeneficiaries: action.data,
			};
		case constants.SET_JOINT_ACCOUNT:
			return {
				...state,
				jointAccount: action.data,
			};
		case constants.SET_ACCOUNT_INVESTMENT:
			return {
				...state,
				accountInvestment: action.data,
			};
		case constants.SET_LIST_INVESTMENT_ACCOUNTS:
			return {
				...state,
				listInvestmentAccounts: action.data,
			};
		case constants.SET_ACCOUNT_INFO:
			return {
				...state,
				dataAccount: action.data,
			};
		case constants.SET_USER_PENDING_TASKS:
			return {
				...state,
				pendingTasks: action.data,
			};
		case constants.UPDATE_USER_PENDING_TASKS:
			return {
				...state,
				pendingTasks: state.pendingTasks - 1,
			};
		case constants.SET_USER_REQUEST_CARD:
			return {
				...state,
				requestCard: action.data,
			};
		case constants.SET_USER_REQUEST_CARD_JOINT_ACCOUNT:
			return {
				...state,
				requestCardJointAccount: action.data,
			};
		case constants.SET_LIST_REQUEST_CARD:
			return {
				...state,
				requestListCard: action.data.state,
				isListCardLoaded: true,
			};
		case constants.SET_BIZUM:
			return {
				...state,
				bizum: {
					...action.data,
					showBizumHeader:
						hasValue(action.data.sessionId) &&
						action.data.result === 'ACCP' &&
						!['BAJA', ''].includes(action.data.userStatus),
					OthrId_Id: action.data.OthrId_Id,
				},
			};
		case constants.SET_WALLETS:
			return {
				...state,
				wallets: action.data,
			};
		case constants.SET_RIESGO:
			return {
				...state,
				indiceRiesgo: action.data,
			};
		case constants.UPDATE_RADICAL_INVESTMENT:
			return {
				...state,
				userProfiling: {
					...state.userProfiling,
					radicalInvestment: action.data.radicalInvestment,
				},
			};
		case constants.UPDATE_DESCRIPTION_NAME_AUTONOMOUS:
			return {
				...state,
				userProfiling: {
					...state.userProfiling,
					descriptionNameAutonomousAccounts:
						action.data.descriptionNameAutonomousAccounts,
				},
			};
		case constants.SET_INVESTMENT_SELECTED:
			return {
				...state,
				investmentSelected: action.data,
			};
		case constants.SET_MOVEMENTS_CARD_ID_SELECTED:
			return {
				...state,
				movementsCardIdSelected: action.data,
			};
		case constants.SET_INVESTMENT_VALID_RAD:
			return {
				...state,
				isValidInvestmentRadical: action.data,
			};
		case constants.SET_DEPOSIT_VALID_RAD:
			return {
				...state,
				isValidDepositRadical: action.data,
			};
		case constants.SET_INVESTMENT_FUND_ITEM:
			return {
				...state,
				investFundItem: action.data,
			};
		case constants.SET_DATA_SUB_WALLET:
			return {
				...state,
				dataSubWallet: action.data,
			};
		case constants.SET_DATA_WALLET:
			return {
				...state,
				dataWallet: action.data,
			};
		case constants.SET_DATA_ORDER_SELECTED:
			return {
				...state,
				orderSelected: action.data,
			};
		case constants.SET_DATA_ORDER_DELETE:
			return {
				...state,
				dataOrderDelete: action.data,
			};
		case constants.SET_DATA_PORTFOLIO_INVESTMENT:
			return {
				...state,
				dataPortfolioInvestment: action.data,
			};
		case constants.SET_DATA_PORTFOLIO_LOADED:
			return {
				...state,
				dataPortfolioLoaded: action.data,
			};
		case constants.SET_DATA_DEPOSIT_SELECTED:
			return {
				...state,
				dataDepositSelected: action.data,
			};
		case constants.SET_DATA_BIZUM_SUBS_SELECTED:
			return {
				...state,
				dataBizumSubscriptionSelected: action.data,
			};
		case constants.SET_BIZUM_TAB_SELECTED:
			return {
				...state,
				bizumTabSelected: action.data,
			};
		case constants.SET_POSITION_ACCOUNT_CAROUSEL_SELECTED:
			return {
				...state,
				accountPositionCarousel: action.data,
			};
		case constants.SET_MOVEMENT_ACCOUNT_ID_SELECTED:
			return {
				...state,
				movementAccountIdSelected: action.data,
			};
		case constants.SET_DISABLED_MENU_TRANSFER:
			return {
				...state,
				disableMenuTransferAccount: action.data,
			};
		case constants.SET_SECURE_SIMULATION:
			return {
				...state,
				insuranceSelected: action.data,
			};
		case constants.SET_INSURANCE_SIMULATION:
			return {
				...state,
				insuranceSimulationSelected: action.data,
			};
		case constants.SET_SIMULATION_LIST:
			return {
				...state,
				simulationlist: action.data,
			};
		case constants.SET_LAST_LOCATION_BEFORE_PREVIOUS_SIMULATIONS:
			return {
				...state,
				lastLocationBeforePreviousSimulations: action.data,
			};
		case constants.SET_LIST_CARDS:
			return {
				...state,
				listCard: action.data,
				isListCardLoaded: true,
			};
		case constants.SET_TYPE_NEW_JOINT_ACCOUNT:
			return {
				...state,
				typeNewJointAccount: action.data,
			};
		case constants.SET_ERROR_ACTIVATE_JOINT_ACCOUNT:
			return {
				...state,
				errorActivateJoinAccount: action.data,
			};
		case constants.SET_SAVINGS:
			return {
				...state,
				savings: action.data,
			};
		case constants.SET_USER_PROFILING_CONFIG:
			return {
				...state,
				userProfilingConfig: action.data,
			};
		case constants.SET_EXPIRED_DOCUMENTATION:
			return {
				...state,
				expiredDocumentation: action.data,
			};
		case constants.SET_EXPIRED_DOCUMENTATION_JOIN_ACCOUNTS:
			return {
				...state,
				expiredDocumentationJoinAccounts: action.data,
		};
		case constants.SET_TYPE_GP_CARD_JOINT_ACCOUNT:
			return {
				...state,
				typeGPCardJointAccount: action.data,
			};
		case constants.SET_DATA_CLIENTS_JOINT_ACCOUNT:
			return {
				...state,
				dataClientsJointAccount: action.data,
			};
		case constants.SET_ACCOUNT_CAROUSEL_SELECTED:
			return {
				...state,
				accountCarouselSelected: action.data,
			};
		case constants.SET_IS_JOINT_ACCOUNT:
			return {
				...state,
				isJointAccount: action.data,
			};
		case constants.SET_SHOW_MODAL_ACCEPT_INVITE_JOINT_ACCOUNT:
			return {
				...state,
				showModalInviteJointAccount: action.data,
			};
		case constants.SET_DATA_GET_CASE_BY_RADICAL_PERSON:
			return {
				...state,
				dataGetCaseByRadicalPerson: {
					...state.dataGetCaseByRadicalPerson,
					[action.data.propiedad]: action.data.valor,
				},
			};
		case constants.SET_DEPOSIT_ITEM:
			return {
				...state,
				depositItem: action.data,
			};
		case constants.SET_DATA_GET_CASE_BY_RADICAL_PERSON_KIDS:
			return {
				...state,
				dataGetCaseByRadicalPersonKids: action.data,
			};
		case constants.SET_INDIVIDUAL_ATRIBUTES_GET_CASE_BY_RADICAL_PERSON_KIDS:
			return {
				...state,
				dataGetCaseByRadicalPersonKids: {
					...state.dataGetCaseByRadicalPersonKids,
					[action.data.propiedad]: action.data.valor,
				},
			};
		case constants.SET_DATA_CLIENTS_KIDS_ACCOUNT:
			return {
				...state,
				dataClientKidsAccount: action.data,
			};
		case constants.SET_LIST_JUNIOR_ACCOUNTS:
			return {
				...state,
				listJuniorAccounts: action.data,
			};
		case constants.SET_JUNIOR_ACCOUNT:
			return {
				...state,
				juniorAccount: action.data,
			};
		case constants.SET_LIST_KIDS_ACCOUNTS:
			return {
				...state,
				listKidsAccounts: action.data,
			};
		case constants.SET_KIDS_ACCOUNT:
			return {
				...state,
				kidsAccount: action.data,
			};
		case constants.SET_ACCOUNT_KIDS_CAROUSEL_SELECTED:
			return {
				...state,
				accountKidsCarouselSelected: action.data,
			};
		case constants.SET_SUB_TIPO_ALTA_BLOQUED_ACCOUNT:
			return {
				...state,
				subTipoAltaBloquedAccount: action.data,
			};
		case constants.SET_GOAL_CAROUSEL_SELECTED:
			return {
				...state,
				goalCarouselSelected: action.data,
			};
		case constants.SET_LIST_GOALS:
			return {
				...state,
				listGoals: action.data,
			};
		case constants.SET_POSITION_GOAL_CAROUSEL_SELECTED:
			return {
				...state,
				goalPositionCarousel: action.data,
			};
		case constants.SET_LIST_KIDS_CARDS:
			return {
				...state,
				listKidsCard: action.data,
			};
		case constants.SET_LIST_AUTONOMOUS_CARDS:
			return {
				...state,
				listAutonomousCard: action.data,
			};
		case constants.SET_POSITION_ACCOUNT_KIDS_CAROUSEL_SELECTED:
			return {
				...state,
				accountKidsPositionCarousel: action.data,
			};
		case constants.SET_ROUTES_FROM_HADER_MOBILE:
			return {
				...state,
				routesFromHeaderMobile: {
					...state.routesFromHeaderMobile,
					[action.data.propiedad]: action.data.valor,
				},
			};
		case constants.SET_DATA_WALLET_CREDIT_ACCOUNT:
			return {
				...state,
				walletCreditAccount: action.data,
			};
		case constants.SET_CARD_ORIGIN:
			return {
				...state,
				originCard: action.data,
			};
		case constants.SET_END_INSURANCES_RESULTS:
			return {
				...state,
				endInsuranceResults: action.data,
			};
		case constants.SET_DATA_PORTFOLIO_DEPOSIT:
			return {
				...state,
				dataPortfolioDeposits: action.data,
			};
		case constants.SET_IS_ORIGIN_GP_KIDS:
			return {
				...state,
				isOriginGPKids: action.data,
			}
		case constants.SET_WALLET_CAROUSEL_SELECTED:
			return {
				...state,
				walletCarouselSelected: action.data,
			};
		case constants.SET_LIST_WALLETS:
			return {
				...state,
				listWallets: action.data,
			};
		case constants.SET_POSITION_WALLET_CAROUSEL_SELECTED:
			return {
				...state,
				walletPositionCarousel: action.data,
			};
		case constants.SET_PORTFOLIO_TYPE_CHILDREN_LIST:
			return {
				...state,
				portfolioTypeChildrenList: action.data,
			};
		case constants.SET_USER_KID_SELECTED:
			return {
				...state,
				userKidSelected: action.data,
			};
		case constants.SET_PROFIL_NEW_WALLET:
			return {
				...state,
				profilNewWallet: action.data,
			};
		case constants.SET_OPEN_MENU_GP:
			return {
				...state,
				menuOpenGP: action.data,
			};
		case constants.SET_LIST_TOTAL_CURRENCY_MINOR_ACCOUNTS:
			return {
				...state,
				listTotalCurrencyMinorAccounts: action.data,
			};
		case constants.SET_CRYPTO_LIST:
			return {
				...state,
				cryptoList: action.data,
			};
		case constants.SET_SELECTED_CRYPTO:
			return {
				...state,
				selectedCrypto: action.data,
			};
		case constants.SET_CONTRATED_CRYPTO_LIST:
			return {
				...state,
				contratedCryptoList: action.data,
			};
		case constants.SET_SELECTED_CONTRATED_CRYPTO:
			return {
				...state,
				selectedContratedCrypto: action.data,
			};
		case constants.SET_CRYPTO_LIST_MYB:
			return {
				...state,
				cryptoListMYB: action.data,
			};
		case constants.SET_CRYPTO_VALID_RAD:
			return {
				...state,
				isValidCryptoRadical: action.data,
			};
		case constants.SET_CJ_FONDOS_VALID_RAD:
			return {
				...state,
				isValidCjFondosRadical: action.data,
			};
		case constants.SET_ORIGIN_PERSONAL_INFORMATION:
			return {
				...state,
				isOriginPersonalInformation: action.data,
			};
		case constants.SET_IS_UPDATE_WALLET:
			return {
				...state,
				isUpdateWallet: action.data,
			};
		case constants.SET_DATA_KYC_LIST:
			return {
				...state,
				kycDataList: [...state.kycDataList, action.data],
			};
		case constants.SET_KYC_ORIGIN_MODAL_GP:
			return {
				...state,
				isKycOriginModalGP: action.data,
			};
		case constants.SET_DATA_KYC_CLEAR:
			return {
				...state,
				kycDataList: action.data,
			};
		case constants.SET_KYC_SELECTED_MODAL_GP:
			return {
				...state,
				kycGPSelected: action.data,
			};
		case constants.SET_ATTACH_DOCUMENT_LIST:
			return {
				...state,
				attachDocumentList: action.data,
			};
		case constants.SET_CONTRACT_DATA:
			return {
				...state,
				contractData: action.data,
			};
		case constants.SET_DATA_DOCUMENT_IDENTITY_VALID_RAD:
			return {
				...state,
				documentIdentityValidRad: action.data,
			};
		case constants.SET_DATA_DOCUMENT_FONDOS_VALID_RAD:
			return {
				...state,
				documentFondosValidRad: action.data,
			};
		case constants.SET_KYC_VIGENTE_VALID_RAD:
			return {
				...state,
				kycVigenteValidRad: action.data,
			}
		case constants.SET_USER_LANGUAGE:
			return {
				...state,
				userLanguage: action.data,
			};
		case constants.SET_KYC_ORIGIN_CRYPTO_OPERATIONS:
			return {
				...state,
				isKycOriginModalCryptoOperations: action.data,
			};
		case constants.SET_IS_FRIENDS_AND_FAMILY:
			return {
				...state,
				isFriendsAndFamily: action.data,
			};
		case constants.TOGGLE_AMOUNT_VISIBILITY:
			return {
				...state,
				isAmountVisible: !state.isAmountVisible,
			};
		case constants.SET_DEPOSIT_RADICAL_IN_ACCOUNT:
			return {
				...state,
				depositRadicalInAccount: action.data,
			};
		case constants.SET_DEPOSIT_RADICAL_IN_ACCOUNT_5000:
			return {
				...state,
				depositRadicalInAccount5000: action.data,
			};
		case constants.SET_DEVICE_SELECTED:
			return {
				...state,
				deviceSelected: action.data,
			};
		case constants.SET_IS_DEVICE_REGISTRATION:
			return {
				...state,
				isDeviceRegistration: action.data,
			};
		case constants.SET_IS_AUTONOMOS:
			return {
				...state,
				isAutonomos: action.data,
			};
		case constants.SET_IS_AUTONOMOS_ACCOUNT_INACTIVE:
			return {
				...state,
				isAutonomosAccountInactive: action.data,
			};
		case constants.SET_SHOW_AUTONOMOS_INACTIVE_MODAL:
			return {
				...state,
				showAutonomosInactiveModal: action.data,
			};
		case constants.SET_IS_ORIGIN_HIRE_WALLET_END:
			return {
				...state,
				isOriginHireWalletEnd: action.data,
			};
		default:
			return state;
	}
};
const AppContextProvider = ({ children }: TAppProviderProps) => {
	const [state, dispatch] = useReducer(appReducer, initialState);
	const value = { state, dispatch };
	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

const useAppContext = () => useContext(AppContext);

export { AppContextProvider, useAppContext };
